import React, { useState } from "react";
import "./App.css";

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [chats, setChats] = useState([]);
  const [theme, setTheme] = useState("cute");

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userText = input;
    setInput("");

    const newMessages = [...messages, { sender: "user", text: userText }];
    setMessages(newMessages);
    setIsTyping(true);

    try {
      const res = await fetch("https://ai-bot-v6rd.onrender.com/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userText }),
      });

      const data = await res.json();

      setTimeout(() => {
        const updated = [...newMessages, { sender: "bot", text: data.reply }];
        setMessages(updated);
        setIsTyping(false);
      }, 800);

    } catch {
      setIsTyping(false);
    }
  };

  const newChat = () => {
    if (messages.length > 0) {
      setChats([...chats, messages]);
      setMessages([]);
    }
  };

  const clearAllChats = () => {
    setChats([]);
    setMessages([]);
  };

  const loadChat = (chat) => {
    setMessages(chat);
  };

  return (
    <div className={`app ${theme}`}>

      {/* Floating Hearts - Screen Level */}
      <div className="floating-hearts">
        <span>💖</span>
        <span>💗</span>
        <span>💕</span>
        <span>💞</span>
      </div>

      {/* Sidebar */}
      <div className="sidebar glass">
        <h2>🌸 Siya’s Assistant</h2>

        <button onClick={newChat}>✨ New Chat</button>
        <button onClick={clearAllChats}>🗑 Clear All</button>

        <select value={theme} onChange={(e) => setTheme(e.target.value)}>
          <option value="cute">💗 Cute Pink</option>
          <option value="dark">🌙 Dark</option>
          <option value="ocean">🌊 Ocean</option>
          <option value="lavender">🌸 Lavender</option>
          <option value="mint">🌿 Mint</option>
          <option value="purple">💜 Purple</option>
        </select>

        <div className="history">
          {chats.map((chat, i) => (
            <p key={i} onClick={() => loadChat(chat)}>
              💌 Chat {i + 1}
            </p>
          ))}
        </div>
      </div>

      {/* Chat Area */}
      <div className="chat-area">
        <div className="messages">
          {messages.map((msg, i) => (
            <div key={i} className={`message ${msg.sender}`}>
              {msg.text}
            </div>
          ))}

          {isTyping && (
            <div className="message bot typing">
              <div className="dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
        </div>

        <div className="input-area glass">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            placeholder="Talk to Siya..."
          />
          <button onClick={sendMessage}>Send 💌</button>
        </div>
      </div>
    </div>
  );
}

export default App;
